/** Convites guia–cliente persistidos na página oculta `/guia-convites-store` (fallback sem API). */

const STORE_KEY = 'naviex-guia-convites-pendentes';

export function getGuiaConvitesPendentesForSync(): unknown[] {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw) as unknown;
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
